import { defineStore } from 'pinia'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    authenticator: null as any,
    userAttributes: null as any,
    subscriptionStatus: null as any,
    billingRenewalRedirectPending: false,
    loggingOut: false
  }),

  actions: {
    beginLogout() {
      this.loggingOut = true
    },
    finishLogout() {
      this.loggingOut = false
    }
  },
  persist: {
    paths: ['userAttributes', 'subscriptionStatus']
  }
})
